<template>
    <div class="modal" v-show="modalShown" v-drag="{handle:'#modal-moving'}">
      <div class="modal-main">
        <!-- 一覧 -->
        <div id="sub_tab_contents_area" :style="{height: subTabContentsAreaH}">
          <div id="sub_tab_contents" @scroll="scroll">
            <!-- 提案中のプランデータ一覧 -->
            <div class="title-area" id="modal-moving">
              <h2>提案中プラン</h2>
            </div>
            <template v-for="fileData in dispFileDataList">
              <div
                class="side_unitlist container"
                v-if="fileData.proposeProductModel.sketchStatus===2"
                v-bind:class="{select_item: selectSpaceJoincd==fileData.spaceJoincd, grabbable: isGrabbable(fileData)}"
                :key="fileData.spaceJoincd"
                :data-space-joincd="fileData.spaceJoincd"
                :data-top-space-id="fileData.topSpaceModel.id"
                :data-object-type="fileData.topSpaceModel.spaceObjectType"
                :data-planning-type="fileData.topSpaceModel.planningType"
                :data-category="fileData.categoryNo"
                @mousedown="$emit('setDraggedFileData', fileData)"
              >
                <div class="side_unitlist_left">
                  <img :src="getFileImg(fileData)" @error="noImage" alt="unitData"/>
                </div>
                <div class="side_unitlist_right">
                  <h4 class="unit_name">
                    <div class="side_plan_name">{{ fileData.fileName }}</div>
                    <span>{{ fileData.fileCode }}</span>
                  </h4>
                  <p class="unit_specification">{{ fileData.objectDataModelList[0].objSpecification }}</p>
                  <p class="unit_caption">{{ fileData.fileCaption }}</p>
                  <div class="edit_button">
                    <a @click="$emit('showContentsDataModal', fileData)" @mousedown.stop>コンテンツ登録</a>
                  </div>
                  <div class="edit_icon">
                    <span v-if="targetSpaceJoincd === fileData.spaceJoincd">編集中</span>
                  </div>
                </div>
                <button class="select-btn" @click="delteProposeProduct(fileData.planDataModel.umPlanid)">取り下げ</button>
              </div>
            </template>
            <!-- その他プランデータ一覧 -->
            <h2>プランリスト</h2>
            <template v-for="fileData in dispFileDataList">
              <div
                class="side_unitlist container"
                v-if="fileData.proposeProductModel.sketchStatus!==2"
                v-bind:class="{select_item: selectSpaceJoincd==fileData.spaceJoincd, grabbable: isGrabbable(fileData)}"
                :key="fileData.spaceJoincd"
                :data-space-joincd="fileData.spaceJoincd"
                :data-top-space-id="fileData.topSpaceModel.id"
                :data-object-type="fileData.topSpaceModel.spaceObjectType"
                :data-planning-type="fileData.topSpaceModel.planningType"
                :data-category="fileData.categoryNo"
                @mousedown="$emit('setDraggedFileData', fileData)"
              >
                <div class="side_unitlist_left">
                  <img :src="getFileImg(fileData)" @error="noImage" alt="unitData"/>
                </div>
                <div class="side_unitlist_right">
                  <h4 class="unit_name">
                    <div class="side_plan_name">{{ fileData.fileName }}</div>
                    <span>{{ fileData.fileCode }}</span>
                  </h4>
                  <p class="unit_specification">{{ fileData.objectDataModelList[0].objSpecification }}</p>
                  <p class="unit_caption">{{ fileData.fileCaption }}</p>
                  <div class="edit_button">
                    <a @click="$emit('showContentsDataModal', fileData)" @mousedown.stop>コンテンツ登録</a>
                  </div>
                  <div class="edit_icon">
                    <span v-if="targetSpaceJoincd === fileData.spaceJoincd">編集中</span>
                  </div>
                </div>
                <button class="select-btn" @click="addProposeProduct(fileData.planDataModel.umPlanid)">提案</button>
              </div>
            </template>
          </div>
        </div>
        <div class="modal-footer">
            <button class="main_btn" @click="applyProposeProduct()">提案確定</button>
            <button class="main_btn" @click="close()">閉じる</button>
        </div>
      </div>
    </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../../../constants/App'
import * as Api from '../../../utils/Api'
import {OBJECT_TYPE, OBJECT_GROUP_TYPE, LICENSE_TYPE} from '../../../constants/Type'
import * as AppUtil from '../../../utils/App'

export default {
  name: 'SketchProposeProductModal',
  data () {
    return {
      modalShown: false,
      sketchId: '',
      index: '',
      /** ファイルデータリスト */
      fileDataList: [],
      /** 表示するファイルデータリスト */
      dispFileDataList: [],
      selectSpaceJoincd: -1,
      dispFileDataListCond: {
        series: 1,
        category: 1,
        // オブジェクトタイプ
        objectType: OBJECT_TYPE.PLAN.code,
        // オブジェクトグループタイプ
        objGroupType: OBJECT_GROUP_TYPE.CABINET.code,
        // 公開プラン
        openFileFlg: false,
        // スケッチオーダープラン
        sketchFlg: false,
        // 特注タイプ
        customType: 0,
        // アクセサリー大カテゴリータイプ
        accessoryCategoryId: null,
        // アクセサリー小カテゴリータイプ
        accessorySubCategoryId: null
      }
    }
  },
  props: {
    targetSpaceJoincd: String
  },
  methods: {
    showModal: function (sketchId, index) {
      this.modalShown = true
      this.sketchId = sketchId
      this.index = index

      let payload = {
        seriesNo: this.seriesNo,
        category: this.dispFileDataListCond.category,
        objectType: this.dispFileDataListCond.objectType,
        objGroupType: this.dispFileDataListCond.objGroupType,
        openFileFlg: this.dispFileDataListCond.openFileFlg,
        sketchFlg: this.dispFileDataListCond.sketchFlg,
        customType: null,
        accessorySubCategoryId: this.dispFileDataListCond.accessorySubCategoryId,
        offset: 0
      }
      // プラン一覧を取得
      axios.post(API_URL.LIST + '/proposeProduct/' + this.sketchId, payload)
        .then(response => {
          this.dispFileDataList = response.data
        }).catch(error => {
          this.modalShown = false
          Api.handleError(error)
        })
    },
    close: function () {
      this.modalShown = false
    },
    /** 提案追加 */
    addProposeProduct: function (umPlanid) {
      this.dispFileDataList = this.dispFileDataList.map((file) => {
        if (file.planDataModel.umPlanid === umPlanid) {
          file.proposeProductModel.sketchStatus = 2
          file.proposeProductModel.umPlanid = umPlanid
        }
        return file
      })
    },
    /** 提案取り下げ */
    delteProposeProduct: function (umPlanid) {
      this.dispFileDataList = this.dispFileDataList.map((file) => {
        if (file.planDataModel.umPlanid === umPlanid) {
          file.proposeProductModel.sketchStatus = 3
          file.proposeProductModel.umPlanid = umPlanid
        }
        return file
      })
    },
    /** 提案決定 */
    applyProposeProduct: function () {
      axios.post(API_URL.LIST + '/applyProposeProduct/' + this.sketchId, this.dispFileDataList)
        .then(response => {
          this.modalShown = false
          this.$emit('updateSketchList')
        }).catch(error => {
          this.modalShown = false
          Api.handleError(error)
        })
        .finally(() => {
          this.onLoad = false
        })
    },
    subTabContentsAreaH: function () {
      return this.dispTrialUserTools
        ? this.isObjTypeUnit ? 'calc(100% - 300px)' : 'calc(100% - 263px)'
        : this.isObjTypeUnit ? 'calc(100% - 160px)' : 'calc(100% - 124px)'
    },
    /** スクロール時 */
    scroll: function (e) {
      const checkScrollHeight = Math.ceil(e.target.scrollTop + e.target.offsetHeight)
      if (!this.onLoad && checkScrollHeight >= e.target.scrollHeight) {
        this.onLoad = true
        this.offset = this.dispFileDataList.length
        this.getFileDataList()
      }
    },
    isGrabbable: function (fileData) {
      return OBJECT_TYPE.PLAN.code !== fileData.topSpaceModel.spaceObjectType
    },
    /** 条件のオブジェクトタイプがユニット */
    isObjTypeUnit: function () {
      return this.dispFileDataListCond.objectType === 'TYPE_OBJ_UNIT'
    },
    /** お試しユーザー用ツール表示 */
    dispTrialUserTools: function () {
      let user = AppUtil.getUserInfo()
      return user && LICENSE_TYPE.TRIAL === user.licenseType
    },
    getFileImg: function (fileData) {
      let contentsDataModel = fileData.contentsDataModel
      if (contentsDataModel != null && contentsDataModel.contentsImgSmall) {
        return this.getContentsResource(fileData.corpId + '/' + contentsDataModel.contentsImgSmall)
      }
      if (fileData.iconImageData) {
        return fileData.iconImageData
      }
      let fileName = fileData.iconName ? fileData.iconName.replace(/'/g, "¥'") : 'noimage'
      return this.getDarosResource(fileName + '.svg')
    },
    getContentsResource: function (image) {
      return AppUtil.getContentsResource(image)
    },
    getDarosResource: function (image) {
      return AppUtil.getDarosResource(image)
    },
    noImage: function (element) {
      element.target.src = AppUtil.getDarosResource('noimage.svg')
    }
  }
}
</script>

<style src="../../../css/planning/side_tab_nav.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.modal{
  position: fixed
}

.data-area {
  padding: 20px;
}
.modal-main{
  height: 500px;
  // max-height: 100%;
}

/** プランリスト */
.data_not_found {
  margin-top: 10px;
  color: #565656;
}
#sub_tab_area select {
  margin-bottom: 20px;
}
.left_contact {
  cursor: pointer;
}
.input {
  margin-left: 10px;
  padding: 4px 12px 3px 12px;
}
.unit_name {
  display: flex;
  height: auto !important;
}
.side_plan_name {
  width: 220px !important;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/SketchProposeProduct.vue